:host {
  width: 100%;
  .group-manage {
    margin-bottom: 16px;
    padding: 8px;
    border: 1.5px solid var(--divider);
    border-radius: 4px;

    transition: all 300ms ease-in-out 0s;
    &__header {
      display: flex;
      align-items: center;
      cursor: pointer;
      .avatar-icon {
        object-fit: cover;
        width: 40px;
        height: 40px;
        border-radius: 4px;
      }
      .title-group {
        margin-left: 8px;
        line-height: 16px;
        @media all and (max-width: 500px) {
          width: 80%;
        }
        &__title {
          width: 175px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          color: var(--font-primary);
          @media all and (max-width: 500px) {
            width: unset;
          }
        }

        &__subtitle {
          font-size: 12px;
          font-weight: 400;
          color: #85a2b6;
        }
      }
      .arrow-down {
        margin-left: auto;
        width: 10px;
        height: 10px;
        transition: all 300ms ease-in-out 0s;
        &.is-visible {
          transform: rotate(180deg);
          transition: all 300ms ease-in-out 0s;
        }
      }
    }

    &__links {
      max-height: 0;
      overflow: hidden;
      transition: all 300ms ease-in-out 0s;
      &.is-visible {
        margin-top: 16px;
        max-height: 500px;
        transition: all 300ms ease-in-out 0s;
      }

      div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        background-color: #fff;
        background-color: var(--bg-primary);
        color: #0098ff;
        color: var(--blue-link);
        cursor: pointer;
        &:hover {
          background-color: #f1f1f1;
          background-color: var(--bg-secondary-hover);
        }

        .bill-count {
          margin-right: auto;
          margin-left: 8px;

          background: #ed2c6e;
          text-align: center;
          color: #fff;
          z-index: 1;
          line-height: 20px;
          font-size: 11px;
          font-weight: 700;
          border-radius: 20px;
          padding: 0 7px;
          &.no-bill {
            background: #3ebf4d;
          }
        }

        .arrow-right {
          width: 10px;
          height: 10px;
        }
      }
    }
  }
}
